import { render } from "./NewTaskModal.vue?vue&type=template&id=ac5ebdbe"
import script from "./NewTaskModal.vue?vue&type=script&lang=js"
export * from "./NewTaskModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__